module.exports = __webpack_public_path__ + "static/media/Bear978_3c.cafa114a.svg";